import { resolve } from '@/core/di';
import { PatientFactory } from '../domain/factories/PatientFactory';
import type { PatientRepository } from '../domain/repositories/PatientRepository';
import { PatientRepositoryToken } from '../di/tokens';

export const patientRepository = (): PatientRepository => resolve(PatientRepositoryToken);
export const patientFactory = (): PatientFactory => resolve(PatientFactory);
